import { isElementNode } from 'anodum';
import wrappersTypes from '../../text-formatting/constants/wrappers-types';

const wrappersElements = Object.values(wrappersTypes).map(({ tagName }) => tagName);

const findClosestWrapperElement = (el) => {
  if (!el) return null;

  if (isElementNode(el)) {
    return el.closest(wrappersElements);
  }
  return findClosestWrapperElement(el.parentNode);
};

export default findClosestWrapperElement;
